// src/views/PrivacyPolicyView.tsx

// 用户隐私页面

// 第三方
import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { ContactComp } from '../components/ContactComponent'

// 自定义
import '../css/privacy.policy.css'
import { COMMON_PAGE } from '../services/Macro'

class PrivacyPolicyView extends React.Component<WithTranslation> {

    state = {
        age: COMMON_PAGE.MIN_AGE,
        lastUpdate: COMMON_PAGE.LAST_UPDATE,
    }

    render() {
        const { i18n, lan } = this.props as any
        if (lan) {
            if (lan == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
        else {
            const lang = i18n.language
            if (lang == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
    }

    renderEn() {
        let langEn = { lan: 'en_US' }
        return (
            <section className='white-section'>
                <div className='show-area'>
                    <h1 className="title-font">
                        <b>
                            Privacy Policy
                        </b>
                    </h1>
                    <br />
                    <div className="text-font-en">
                        <div>
                            <b>Latest update: </b>{this.state.lastUpdate}
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                1. The Introduction of Our Privacy Policy
                            </b>
                        </div>
                        <div className="paragraph">
                            Please read the following terms and conditions carefully before using Our Service.
                        </div>
                        <div className="paragraph">
                            This Privacy Policy describes the information ("<b>Personal data</b>") that we collect from you on the Service, how we use and disclose such information, and the steps we take to protect such information.
                        </div>
                        <div className="paragraph">
                            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
                        </div>
                        <div className="paragraph">
                            This Policy is incorporated into and is subject to the Terms of Services.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                2. About the Users' Personal Data
                            </b>
                        </div>
                        <div className="h2-font-en paragraph">
                            <b>
                                2.1 The category of Personal Data that we collect
                            </b>
                        </div>
                        <div className="paragraph">
                            When you use the Service, you may provide and we may collect your personal data, which is information that specifically identifies you. Personal data collected through the service includes your name, date of birth, email address, your symptom information that you may enter into the App, and other personal information you may provide to us. You may provide us with personal information in various ways in the Service. For example, you provide us with personal information when you register for an account, use the Service, or send us customer service-related requests.
                        </div>
                        <div className="paragraph">
                            We may obtain information, including personal information, from third parties and sources other than the Service, such as our partners. If we combine or associate information from other sources with personal information that we collect through the Service, we will treat the combined information as personal information in accordance with this Policy.
                        </div>
                        <div className="paragraph">
                            When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, unique device identifiers and other diagnostic data.
                        </div>
                        <br />
                        <div className="h2-font-en paragraph">
                            <b>
                                2.2 The Way And Purpose We Use Personal Data
                            </b>
                        </div>
                        <div className="paragraph">
                            We use Personal Data we collect on the Service in a variety of ways in providing the Service and operating our business, including the following:
                        </div>
                        <div className="paragraph">
                            To provide and maintain our Service, including to monitor the usage of our Service.
                        </div>
                        <div className="paragraph">
                            To manage Your Account: to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.
                        </div>
                        <div className="paragraph">
                            To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.
                        </div>
                        <div className="paragraph">
                            To provide You with news, special offers and general information about other goods, services unless You have opted not to receive such information.
                        </div>
                        <div className="paragraph">
                            To manage Your requests: To attend and manage Your requests to Us.
                        </div>
                        <div className="paragraph">
                            For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.
                        </div>
                        <div className="paragraph">
                            We may collect, process, retain, or disclose your information for legitimate business purposes in accordance with applicable laws and regulations. We process your information for the following purposes:
                        </div>
                        <div className="paragraph">
                            As required to enable our business and pursue our legitimate business interests, to the extent our interests are not restricted by your lawful data protection rights.
                        </div>
                        <div className="paragraph">
                            As necessary to protect our legitimate business interests, legal rights, and legal or commercial obligations.
                        </div>
                        <div className="paragraph">
                            As required to comply with applicable laws and regulations.
                        </div>
                        <div className="paragraph">
                            In accordance with consent provided by you.
                        </div>
                        <div className="paragraph">
                            Except as described in this Policy, we will not disclose your information that we collect on the Service to third parties without your consent. We may disclose information to third parties if you consent to us doing so, as well as in the following circumstances:
                        </div>
                        <div className="paragraph">
                            We will provide the symptom and other information you enter into the Service, as well as information gathered from the device(s) linked to your account.
                        </div>
                        <div className="paragraph">
                            We may work with third-party service providers to provide application development, analytics, hosting, maintenance, and other services for us. We also work with third-party service providers to create insights and suggestions. These third parties may have access to or process your information as part of providing those services for us. Generally, we limit the information provided to these service providers to that which is necessary for them to perform their functions.
                        </div>
                        <div className="paragraph">
                            We may make certain automatically-collected, aggregated, or otherwise non-personally-identifiable information available to third parties for various purposes, including
                        </div>
                        <div>
                            <b>(i)</b> compliance with various reporting obligations;
                        </div>
                        <div>
                            <b>(ii)</b> for business purposes;
                        </div>
                        <div>
                            or
                        </div>
                        <div>
                            <b>(iii)</b> to assist such parties in understanding our users, and usage patterns for certain programs, content, services, and/or functionality available through the Service.
                        </div>
                        <br />
                        <div className="paragraph">
                            We may disclose your information if required to do so by law or in the good-faith belief that such action is necessary to comply with applicable laws, in response to a court order, judicial or other government subpoena or warrant, or to otherwise cooperate with law enforcement or other governmental agencies.
                        </div>
                        <div className="paragraph">
                            We also reserve the right to disclose your information that we believe, in good faith, is appropriate or necessary to
                        </div>
                        <div>
                            <b>(i)</b> take precautions against liability,
                        </div>
                        <div>
                            <b>(ii)</b> protect ourselves or others from fraudulent, abusive, or unlawful uses or activity,
                        </div>
                        <div>
                            <b>(iii)</b> investigate and defend ourselves against any third-party claims or allegations,
                        </div>
                        <div>
                            <b>(iv)</b> protect the security or integrity of the Service and any facilities or equipment used to make the Service available,
                        </div>
                        <div>
                            or
                        </div>
                        <div>
                            <b>(v)</b> protect our property or other legal rights (including, but not limited to, enforcement of our agreements) or the rights, property, or safety of others.
                        </div>
                        <br />
                        <div className="paragraph">
                            Information about our users, including personal information, may be disclosed and otherwise transferred to an acquirer, successor or assignee as part of any merger, acquisition, debt financing, sale of assets, or similar transaction, as well as in the event of an insolvency, bankruptcy or receivership in which information is transferred to one or more third parties as one of our business assets.
                        </div>
                        <div className="paragraph">
                            We also may disclose your information in response to your lawful request to disclose your information to a third party or in any other manner to which you consent.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                3. The Rights of Users
                            </b>
                        </div>
                        <div className="paragraph">
                            The users have the right to request information and access to the personal data we have collected from and of you. You also have the right to request that we replenish, rectify, anonymize or delete any incomplete, incorrect, unnecessary or outdated personal data we hold on you. However, we cannot delete such personal data that is necessary for compliance with binding legal obligations or if the personal data must be retained according to applicable laws. You have the right to request and receive the personal data we have collected on you in a commonly used and machine-readable form. In case you consider your personal data collected by us to be inaccurate, you do not wish your personal data to be deleted where the processing of your personal data has been deemed unlawful or the personal data is no longer necessary, or you have objected to the processing and the existence of legitimate grounds for processing is still under consideration, you may request restriction of processing of your personal data.
                        </div>
                        <div className="paragraph">
                            You may also at any time object to your personal data being processed for direct marketing purposes, sending promotional materials, profiling, or for the performance of market research. Further, where your personal data is processed based on your consent, you have the right to withdraw your consent for such processing at any time.
                        </div>
                        <div className="paragraph">
                            In case you wish to make use of your rights mentioned above, you may, as appropriate and in accordance with applicable laws, exercise such rights by contacting us through the contact points referred in the marketing materials or below in this Policy. In some cases, especially if you wish us to delete or cease the processing of your personal data, this may also mean that we may not be able to continue to provide the services to you.
                        </div>
                        <div className="paragraph">
                            Please note that we may need to identify you and to ask for additional information in order to be able to fulfill your above requests. Please also note that applicable law may contain restrictions and other provisions that relate to your above rights.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                4. Children's Privacy
                            </b>
                        </div>
                        <div className="paragraph">
                            Our Service does not address anyone under the age of {this.state.age}. We do not knowingly collect personally identifiable information from anyone under the age of {this.state.age}. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of {this.state.age}  without verification of parental consent, We take steps to remove that information from Our servers.
                        </div>
                        <div className="paragraph">
                            If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                5. Third-Party Services
                            </b>
                        </div>
                        <div className="paragraph">
                            The Service may contain features or links to Websites and services provided by third parties. Any information you provide on third-party sites or services is provided directly to the operators of such services and is subject to those operators’ policies, if any, governing privacy and security, even if accessed through the Service. We are not responsible for the content or privacy and security practices and policies of third-party sites or services to which links or access are provided through the Service. We encourage you to learn about third parties’ privacy and security policies before providing them with information.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                6. DATA SECURITY
                            </b>
                        </div>
                        <div className="paragraph">
                            We will implement appropriate technical and organizational security measures to prevent and minimize risks associated with providing and processing personal data.
                        </div>
                        <div className="paragraph">
                            Such security measures include, where appropriate, the use of firewalls, secure server facilities, encryption, implementing proper access rights management systems and processes, careful selection of processors, sufficient training of our personnel involved in the processing, and other necessary measures to provide appropriate protection for your personal data against unauthorized use or disclosure. Where appropriate, we may also take back-up copies and use other such means to prevent accidental damage or destruction of your personal data.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                7. Changes To the Privacy Policy
                            </b>
                        </div>
                        <div className="paragraph">
                            We reserves the right to make changes to this privacy policy at any time by notifying you on this page and/or make reasonable efforts to notify you via any contact information available to us. It is strongly recommended to check this page often, referring to the date of  the last modification listed at the bottom. Your continued use of the Service after the revised Policy has become effective indicates that you have read, understood and agreed to the current version of this Policy.
                        </div>
                        <br />
                        <div className='h1-font-en paragraph'>
                            <b>
                                8. Contact Us
                            </b>
                        </div>
                        <div className="paragraph">
                            If you have any questions about the Privacy Policy, You can contact us by the following ways:
                        </div>
                        <ContactComp {...langEn} />
                        <br />
                    </div>
                </div>
            </section>
        )
    }

    renderCn() {
        let langZh = { lan: 'zh_CN' }
        return (
            <section className='white-section'>
                <div className='show-area'>
                    <h1 className="align-center title-font">
                        隐私政策
                    </h1>
                    <br />
                    <div className="text-font">
                        <div>
                            <b>最新更新：</b>{this.state.lastUpdate}
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                1. 隐私政策简介
                            </b>
                        </div>
                        <br />
                        <div>
                            在使用我们的服务之前，请仔细阅读以下条款和条件。
                        </div>
                        <br />
                        <div>
                            本隐私政策描述了我们从您使用服务时收集的信息（“<b>个人数据</b>”），我们如何使用和披露这些信息，以及我们采取哪些步骤来保护这些信息。
                        </div>
                        <br />
                        <div>
                            我们使用您的个人数据来提供和改进服务。使用本服务即表示您同意根据本隐私政策收集和使用信息。
                        </div>
                        <br />
                        <div>
                            本政策已纳入服务条款并受其约束。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                2. 关于用户个人数据
                            </b>
                        </div>
                        <br />
                        <div>
                            <b>
                                2.1 我们收集的个人数据类别
                            </b>
                        </div>
                        <br />
                        <div>
                            当您使用本服务时，您可能会提供且我们可能会收集您的个人数据，这些数据能够明确识别您的身份。通过服务收集的个人数据包括您的姓名、出生日期、电子邮件地址、您可能在应用程序中输入的症状信息以及您可能向我们提供的其他个人信息。您可以通过服务以多种方式向我们提供个人信息。例如，当您注册账户、使用服务或向我们发送客户服务相关请求时，您会向我们提供个人信息。
                        </div>
                        <br />
                        <div>
                            我们可能从第三方和服务之外的其他来源获取信息，包括个人信息，如我们的合作伙伴。如果我们将其他来源的信息与通过服务收集的个人信息相结合或关联，我们将根据本政策将合并后的信息作为个人信息处理。
                        </div>
                        <br />
                        <div>
                            当您通过移动设备访问服务时，我们可能会自动收集某些信息，包括但不限于您使用的移动设备类型、您的移动设备唯一ID、您移动设备的IP地址、您的移动操作系统、唯一设备标识符和其他诊断数据。
                        </div>
                        <br />
                        <div>
                            <b>
                                2.2 我们使用个人数据的方式和目的
                            </b>
                        </div>
                        <br />
                        <div>
                            我们以多种方式使用在服务中收集的个人数据来提供服务和运营业务，包括：
                        </div>
                        <br />
                        <div>
                            - 提供和维护我们的服务，包括监控服务的使用情况
                        </div>
                        <div>
                            - 管理您的账户：管理您作为服务用户的注册。您提供的个人数据可使您访问作为注册用户可使用的服务的不同功能
                        </div>
                        <div>
                            - 联系您：通过电子邮件、电话、短信或其他电子通信形式就更新或与功能、产品或合同服务相关的信息与您联系
                        </div>
                        <div>
                            - 向您提供新闻、特别优惠和有关其他商品、服务的一般信息，除非您选择不接收此类信息
                        </div>
                        <div>
                            - 管理您的请求：处理和管理您向我们提出的请求
                        </div>
                        <div>
                            - 业务转让：我们可能使用您的信息来评估或进行合并、剥离、重组、重组、解散或出售或转让我们的部分或全部资产
                        </div>
                        <br />
                        <div>
                            我们可能根据适用法律法规出于合法商业目的收集、处理、保留或披露您的信息。我们出于以下目的处理您的信息：
                        </div>
                        <br />
                        <div>
                            - 在您的合法数据保护权利不受限制的范围内，为实现我们的商业目的和追求合法商业利益所需
                        </div>
                        <div>
                            - 为保护我们的合法商业利益、法律权利和法律或商业义务所必需
                        </div>
                        <div>
                            - 为遵守适用的法律法规所需
                        </div>
                        <div>
                            - 根据您提供的同意
                        </div>
                        <br />
                        <div>
                            除本政策所述外，未经您同意，我们不会向第三方披露我们在服务中收集的您的信息。在以下情况下，我们可能会向第三方披露信息：
                        </div>
                        <br />
                        <div>
                            - 如果您同意我们这样做
                        </div>
                        <div>
                            - 我们将提供您输入服务的症状和其他信息，以及从与您账户关联的设备收集的信息
                        </div>
                        <div>
                            - 我们可能与第三方服务提供商合作提供应用程序开发、分析、托管、维护和其他服务
                        </div>
                        <div>
                            - 我们可能会出于各种目的向第三方提供自动收集的、汇总的或其他非个人身份信息
                        </div>
                        <div>
                            - 如果法律要求或出于善意认为有必要披露，我们可能会披露您的信息
                        </div>
                        <div>
                            - 我们还保留在善意认为适当或必要时披露您的信息的权利
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                3. 用户权利
                            </b>
                        </div>
                        <br />
                        <div>
                            用户有权要求获取我们收集的关于您的个人数据的信息和访问权限。您还有权要求我们补充、纠正、匿名化或删除任何不完整、不正确、不必要或过时的个人数据。但是，我们无法删除为遵守约束性法律义务所必需的个人数据，或根据适用法律必须保留的个人数据。您有权要求并以常用和机器可读的形式接收我们收集的关于您的个人数据。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                4. 儿童隐私
                            </b>
                        </div>
                        <br />
                        <div>
                            我们的服务不面向{this.state.age}岁以下的任何人。我们不会故意收集{this.state.age}岁以下任何人的可识别个人信息。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                5. 第三方服务
                            </b>
                        </div>
                        <br />
                        <div>
                            本服务可能包含第三方提供的网站和服务的功能或链接。我们不对通过服务访问的第三方网站或服务的内容或隐私和安全做法及政策负责。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                6. 数据安全
                            </b>
                        </div>
                        <br />
                        <div>
                            我们将实施适当的技术和组织安全措施，以防止和最大限度地减少与提供和处理个人数据相关的风险。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                7. 隐私政策的变更
                            </b>
                        </div>
                        <br />
                        <div>
                            我们保留随时更改本隐私政策的权利。建议您经常查看本页面，参考底部列出的最后修改日期。
                        </div>
                        <br />
                        <div className='h1-font'>
                            <b>
                                8. 联系我们
                            </b>
                        </div>
                        <br />
                        <div>
                            如果您对隐私政策有任何问题，您可以通过以下方式联系我们：
                        </div>
                        <br />
                        <ContactComp {...langZh} />
                        <br />
                    </div>
                </div>
            </section >
        )
    }

}
export const PrivacyPolicyPage = withTranslation()(PrivacyPolicyView)